import { render, staticRenderFns } from "./CarTable.vue?vue&type=template&id=6ff72420&scoped=true"
import script from "./CarTable.vue?vue&type=script&lang=js"
export * from "./CarTable.vue?vue&type=script&lang=js"
import style0 from "./CarTable.vue?vue&type=style&index=0&id=6ff72420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff72420",
  null
  
)

export default component.exports